// extracted by css-extract-rspack-plugin
export default {"container":"OpenInLocalAgentButton-module__container__fWL3Q"};